<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
                                             <!--  兩個頁籤 vue 共用此 modal  -->
            <span class="text">您確定要刪除「{{inputData.name || inputData.favorite_name}}」嗎？</span>
          </div>
          <div class="action text-right">
            <a @click="$emit('close')" class="btn btn-default">取消</a>
            <a @click="$emit('confirm')" class="btn btn-primary">確定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {deleteCust} from '../../service';

export default {
  name: 'ConfirmDelete',
  computed: {
    ...mapGetters(['BaseUrl', 'CustInfo'])
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: [ Object , String ],
      default: () =>{
        return {}
      }
    },
  },
  methods:{

  }
}
</script>
